import React from 'react';

const StockIcon = () => (
  <svg
    style={{ color: '#0f0f0f', fontSize: '16px', width: '16px', height: '16px' }}
    viewBox="0 0 512 512"
  >
    <path d="M64 96a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32v48H64zm0 112h384v208a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32zm96 64v48h64v-48zm96 0v48h96v-48z" />
  </svg>
);

export default StockIcon;
